import { DateHelper } from "@bryntum/schedulerpro";

export default {  
  name: "SchedulerUiLogicMixin",
  
  data() {
    return {  };
  },

  
  methods: {
    getInitialMode() { 
      return this.plannerScope;
    },
    getInitialStartDate() { 
      return this.startDate;
    },
    getInitialEndDate() { 
      return this.endDate;
    },
    getInitialGroupBy() { 
      return this.UserGroupBy;
    },

    getSchedulerStartAndEnd(date) {
      if (!date) { date = new Date(); }
      var onlyWH = this.limitToWorkHours;
      var start, end;
      switch (this.plannerScope) {
        case 'QDay':
          start = DateHelper.add(DateHelper.clearTime(date), (onlyWH ? this.WorkhourStart : 0), 'hour'); //clear hours then set starttime correctly
          end = DateHelper.add(DateHelper.clearTime(date), (onlyWH ? (this.WorkhourEnd + 1) : 24), 'hour'); //clear hours then set endtime correctly
          break;
        case 'QWeek':
          var firstDayOfWeek = 1; //1 is monday, 2 is tuesday and so on...
          var weekLength = onlyWH ? 5 : 7; //defines how many days from start are inculded. (so if firstDayOfWeek is monday and weekLength is 5 it gives monday to friday)
          start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + firstDayOfWeek);
          end = new Date(date.getFullYear(), date.getMonth(), start.getDate() + (weekLength - 1), 23, 59, 59);
          break;
        case 'QMonth':
          start= new Date(date.getFullYear(), date.getMonth(), 1);
          end= new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
          break;
        default:
          console.error("Unknown planner scope: " + this.plannerScope);
      }
      this.startDate = start;
      this.endDate = end;
    },

    setCalendarDate(date) {
      this.$store.dispatch("plannerstore/SetCalendarStartDate", date);
    },

    setSchedulerStartAndEnd(date) {
      this.getSchedulerStartAndEnd(date);
      //console.log('setSchedulerStartAndEnd');
      if (this.scheduler) {
        this.scheduler.setTimeSpan(this.startDate, this.endDate);
      }
      this.getSchedulerElements();
      //this.scheduler.scrollLeft = 0; // reset scroll
      //await eventStore.loadDataAsync([{ startDate, endDate }, ...]);
    },

    setPlannerScope(val) { 
      this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerScope", value: val })
    },

    changeViewPreset(val) {
      if (this.scheduler) {
        this.scheduler.viewPreset = val;
        this.scheduler.fillTicks = (val != 'QDay');
        this.scheduler.features.timeRanges.showCurrentTimeLine = (val == 'QDay');
        this.scheduler.timeRanges = (val != 'QDay') ? [this.todayTimeRange] : [], //[this.todayTimeRange, ...this.weekendTimeRange] : [ ...this.weekendTimeRange],
        //console.log('changeViewPreset', val);
        this.setSchedulerStartAndEnd(this.calendarStartDate);
      }
      else {
        console.error('No scheduler to change mode on');
      }
    },

    setGroupBy() {
      //console.log('setGroupBy', this.scheduler.features.group);
      if (this.UserGroupBy) {
        this.scheduler.features.group._disabled = false;
        this.scheduler._resourceStore.group({ field: this.UserGroupBy });
      }
      else {
        this.scheduler.features.group._disabled = true;
        this.scheduler._resourceStore.clearGroupers();
      }
    },

    filterResourceList() {
      var list = Object.assign([], this.resourceList);

      if (this.hiddenUserList && this.hiddenUserList.length > 0) {
        list = list.filter(x => !this.hiddenUserList.includes(x.id));
      }

      if (this.plannerDepartmentList && this.plannerDepartmentList.length > 0) {
        //console.log('filtering by department', list);
        list = list.filter(x => this.plannerDepartmentList.includes(x.departmentId));
      }

      return Object.assign([], list);
    },
  },

  computed: {
    limitToWorkHours() {
      return this.$store.getters["prefrences/Prefrence"]("LimitToWorkHours");
    },
    WorkhourStart() {
      var stored = this.$store.getters["plannerstore/WorkhourStart"];
      return stored;
      //var rounded = (Math.round(stored * 4) / 4).toFixed(2);
      //return rounded;
    },
    WorkhourEnd() {
      var stored = this.$store.getters["plannerstore/WorkhourEnd"];
      return stored;
      //var rounded = (Math.round(stored * 4) / 4).toFixed(2);
      //return rounded;
    },

    plannerScope() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerScope");
    },

    calendarStartDate() {
      return this.$store.getters["plannerstore/CalendarDateStart"];
    },

    hiddenUserList() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerHiddenUserList");
    },

    UserGroupBy() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerUserGroupBy");
    },

    plannerDepartmentList() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerDepartmentList");
    },
  },

  watch: {
    plannerScope: function (val) {
      this.changeViewPreset(val);
    },

    limitToWorkHours: function () {
      this.setSchedulerStartAndEnd(this.calendarStartDate);
    },

    calendarStartDate: function (val) {
      this.setSchedulerStartAndEnd(val);
    },

    UserGroupBy: function () {
      this.setGroupBy();
    },

    plannerDepartmentList: function () {
      this.getSchedulerElements();
    },

    hiddenUserList: function () {
      this.getSchedulerElements(); //just do this init everything again
      /*
      this.filteredResourceList = this.filterResourceList();
      if (this.scheduler) {
        this.scheduler.resources = this.filteredResourceList;
      }
      */
    },
  },
};